export default "__VITE_ASSET__BWlcgTcq__"